/**
 * V7 final role taxonomy for the wheere-customer app.
 *
 * Deleted (V7 cleanup):
 * - SUPERADMIN / WHEERE_MAINTAINER — legacy bypass aliases of PLATFORM_ADMIN, removed from KC.
 * - CUSTOMER_ADMIN / CUSTOMER_READER (deleted in V4) — superseded by ORG_CUSTOMER for end-users
 *   and the ORG_* family for fleet management.
 *
 * Access matrix (canonical):
 *   ORG_CUSTOMER     → wheere-customer ONLY (no inside, no integrator)
 *   ORG_VIEWER       → wheere-customer + wheere-integrator (read-only on org resources)
 *   ORG_OPERATOR     → wheere-customer + wheere-integrator (write on org resources)
 *   ORG_ADMIN        → wheere-customer + wheere-integrator (full on their org)
 *   PLATFORM_SUPPORT → all three apps, read-only across every org
 *   PLATFORM_ADMIN   → all three apps, full bypass
 */
export type Role = 'PLATFORM_ADMIN' | 'PLATFORM_SUPPORT' | 'ORG_ADMIN' | 'ORG_OPERATOR' | 'ORG_VIEWER' | 'ORG_CUSTOMER';

/** Anyone in this list can authenticate against wheere-customer. */
export const CUSTOMER_ROLES: Role[] = [
  'ORG_CUSTOMER',
  'ORG_VIEWER',
  'ORG_OPERATOR',
  'ORG_ADMIN',
  'PLATFORM_SUPPORT',
  'PLATFORM_ADMIN',
];
